import { RIGHTS } from "@/enums";
import { useUserContext } from "@/providers";

export function useIsAdmin() {
  const { hasRight } = useUserContext();
  return hasRight([RIGHTS.writeAllProjects]);
}
